import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import AddressModal from "../../../components/Modal/AddressModal";
import AddressCard from "./addressCard";
import {LIST_HEADERS, useActionsList, usePermsForActions} from "./addressTable.constants";
import {useAddressTableActions} from "./useAddressTableActions";
import {useAddressTableData} from "./useAddressTableData";
import {useAddressSearchOptions} from "./useAddressSearchOptions";

const AddressTable = () => {
  const actionsList = useActionsList();
  const permsForActions = usePermsForActions();
  const {searchOptions} = useAddressSearchOptions();
  const {
    addressList,
    addressTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
  } = useAddressTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    onSubmit,
    selectedRow,
  } = useAddressTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isEditModalOpen && (
        <AddressModal
          data={selectedRow}
          formSubmission
          onCancel={closeEditModal}
          onSubmit={onSubmit}
          open={isEditModalOpen}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete Address"}
          modalBody={"Are you sure you want to delete this Address ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          listItems={addressList}
          listHeaders={LIST_HEADERS}
          rowClickable
          onSelectAction={handleActionSelection}
          withActions
          actionsList={actionsList}
          permsForActions={permsForActions}
          totalCount={addressTotalCount}
          withPagination={paginationConfig}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Address"}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={AddressCard}
        />{" "}
      </div>
    </Fragment>
  );
};

AddressTable.propTypes = {};

export default AddressTable;
